import { Theme } from "@mui/material";
import { Todo } from "../../../../../types/types";
import EventItem from "../../EventItem/EventItem";

interface TodoListProps {
    todos: Todo[];
    getTodoColor: (todo: Todo, theme: Theme) => string | undefined;
    onTodoClick: (todo: Todo) => void;
    showTime: boolean;
    theme: Theme;
}

export const TodoList: React.FC<TodoListProps> = ({
    todos,
    getTodoColor,
    onTodoClick,
    showTime,
    theme
}) => (
    <>
        {todos.map((todo, index) => (
            <EventItem
                key={index}
                todo={todo}
                color={getTodoColor(todo, theme) || 'primary.main'}
                onClick={() => onTodoClick(todo)}
                showTime={showTime}
            />
        ))}
    </>
); 